import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import { themes } from "../../themes/themes";
interface PropVal {
  name: string;
  designation: string;
  transferTo: string;
}
const RecentlyTransferredARTile = ({
  designation,
  name,
  transferTo,
}: PropVal) => {
  return (
    <Box
      style={{
        backgroundColor: "#F5F5FA66",
        height: "auto",
        padding: "1em",
        borderRadius: "10px",
        marginTop: "1em",
        display: "flex",
      }}
    >
      <Box>
        <Avatar />
      </Box>
      <Box style={{ paddingLeft: "5px" }}>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.darkBlue,
            fontSize: "0.875em",
            fontWeight: "bold",
          }}
        >
          {name}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.grey_colorDesignationAR,
            fontSize: "0.75em",
            fontWeight: "bold",
          }}
        >
          {designation}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.greySubtitle,
            fontSize: "0.7em",
            fontWeight: "bold",
          }}
        >
          Transfer To {"        "}{" "}
          <span
            style={{
              color: themes.darkBlue,
              padding: "4px",
              backgroundColor: "#E6E8F0",
              borderRadius: "4px",
              alignSelf: "center",
              paddingLeft: "5px",
            }}
          >
            {transferTo}
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default RecentlyTransferredARTile;
